









import { useEffect, useState } from "react";
import { getEmployeesApi, deleteUserApi } from "../../app/api";
import EditUser from "../employees/EditUser";

import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import { createPortal } from "react-dom";

import ChatDrawer from "../chat/ChatDrawer";

const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

export default function Employees() {

  const [openChat, setOpenChat] = useState(false);


  const [editUser, setEditUser] = useState(null);
  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [deleteUser, setDeleteUser] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const res = await getEmployeesApi({
        page: 1,
        limit: 1000,
        search,
        role_id: 2,
      });
      setEmployees(res.success ? res.data || [] : []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, [search]);

  useEffect(() => {
    const keyword = search.toLowerCase().trim();
    if (!keyword) {
      setFilteredEmployees(employees);
      return;
    }

    const filtered = employees.filter((emp) => {
      const fullName =
        `${emp.first_name} ${emp.last_name}`.toLowerCase();
      return (
        fullName.includes(keyword) ||
        emp.email?.toLowerCase().includes(keyword)
      );
    });

    setFilteredEmployees(filtered);
  }, [search, employees]);

  const confirmDelete = async () => {
    if (!deleteUser) return;
    setDeleting(true);
    try {
      const res = await deleteUserApi(deleteUser.id);
      if (res.success) {
        setDeleteUser(null);
        fetchEmployees();
      }
    } finally {
      setDeleting(false);
    }
  };

  const formatDate = (d) =>
    new Date(d).toLocaleDateString("en-IN");

    const sortedEmployees = [...filteredEmployees].sort((a, b) => {
      const nameA = `${a.first_name || ""} ${a.last_name || ""}`.toLowerCase();
      const nameB = `${b.first_name || ""} ${b.last_name || ""}`.toLowerCase();
      return nameA.localeCompare(nameB);
    });
    

  return (
    <>
      <div className="
        rounded-2xl p-5 md:mt-20
        bg-[#12082F]
        text-white border border-white/10
        shadow-2xl
      ">
        {/* Header */}
        <div className="flex flex-col  justify-between items-start mb-4 gap-2">
          {/* <h3 className="font-bold text-2xl">Employees</h3> */}

          <div className="flex justify-between items-center w-full">

<h3 className="font-bold text-2xl">Employees</h3>

<button
  onClick={() => setOpenChat(true)}
  className="px-4 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-sm"
>
  Chat
</button>

</div>
          <input
            placeholder="Search by name or email"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="px-10 py-1.5 rounded-md bg-white/10  text-sm shadow-lg"
          />
        </div>

        {/* Table */}
       <div className="overflow-x-auto rounded-md">
          <table className="min-w-[820px] w-full border-collapse rounded-md text-sm shadow-lg">
            <thead className=" text-white border-b border-white/10">
              <tr>
                <th className="text-left w-[260px]">Name</th>
                <th className=" text-left w-[260px]">Email</th>
                <th className=" text-left w-[110px]">Role</th>
                <th className="text-left w-[180px]">Job</th>
                <th className="text-left w-[100px]">Joined</th>
                <th className="text-left w-[80px] ">Edit</th>
                <th className="text-left w-[90px] ">Delete</th>
              </tr>
            </thead>

            <tbody>
              {loading && (
                <tr>
                  <td colSpan="7" className="py-6 text-center opacity-60">
                    Loading...
                  </td>
                </tr>
              )}

              {!loading &&
                // filteredEmployees.map((emp) => (
                  sortedEmployees.map((emp) => (

                  <tr
                    key={emp.id}
                    className="border-b py-5 border-white/5 hover:bg-white/5"
                  >
                    {/* Name */}
                    <td className=" py-2 w-[260px]">
                      <div
                        className="flex items-center gap-3 cursor-pointer"
                        onClick={() => navigate(`/users/${emp.id}`)}
                      >
                        <div className="w-8 h-8 rounded-full bg-white/20 overflow-hidden">
                          {emp.profile_pic ? (
  <img
    src={`${IMAGE_BASE_URL}${emp.profile_pic}`}
    className="w-full h-full object-cover"
  />
) : (
  <div className="w-full h-full flex items-center justify-center bg-white/10">
    <User size={18} className="text-white/60" />
  </div>
)}

                        </div>

                        <span className="font-medium truncate">
                          {emp.first_name} {emp.last_name}
                        </span>
                      </div>
                    </td>

                    {/* Email */}
                    <td className="w-[260px] truncate opacity-80">
                      {emp.email}
                    </td>

                    {/* Role */}
                    <td className="w-[110px]">
                      <span className="
                        px-2 py-1 rounded-full
                        bg-blue-500/20 text-blue-300
                        text-xs
                      ">
                        {emp.role_name}
                      </span>
                    </td>

                    {/* Job */}
                    <td className="w-[180px] truncate">
                      {emp.job_title || "—"}
                    </td>

                    {/* Joined */}
                    <td className="w-[100px] text-xs opacity-70">
                      {formatDate(emp.created_at)}
                    </td>

                    {/* Edit */}
                    <td className="w-[80px] text-center">
                      <button
                        // onClick={() => navigate(`/users/${emp.id}/edit`)}
                        onClick={() => setEditUser(emp)}
                        className="px-3 py-1 rounded bg-white/10 hover:bg-white/20 text-xs"
                      >
                        Edit
                      </button>
                    </td>

                    {/* Delete */}
                    <td className="w-[90px] text-center">
                      <button
                        onClick={() => setDeleteUser(emp)}
                        className="px-3 py-1 rounded bg-red-500/20 text-red-300 hover:bg-red-500 hover:text-white text-xs"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Delete Modal */}
    
{deleteUser &&
  createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-md">
      
      <div
        className="
          relative
          w-full max-w-md
          p-8
          rounded-2xl
          bg-white/10
          backdrop-blur-xl
          border border-white/20
          shadow-[0_0_40px_rgba(0,0,0,0.6)]
          text-white
        "
      >
        {/* Soft glow border effect */}
        <div className="absolute inset-0 rounded-2xl border border-white/10 pointer-events-none"></div>

        <h3 className="text-xl font-semibold mb-3 tracking-wide">
          Delete Employee
        </h3>

        <p className="text-sm text-white/70 mb-8">
          Are you sure you want to delete{" "}
          <span className="font-medium text-white">
            {deleteUser.first_name} {deleteUser.last_name}
          </span>
          ?
        </p>

        <div className="flex justify-end gap-4">
          <button
            onClick={() => setDeleteUser(null)}
            className="
              px-6 py-2 rounded-lg
              bg-white/15
              hover:bg-white/25
              transition-all duration-200
            "
          >
            Cancel
          </button>

          <button
            onClick={confirmDelete}
            disabled={deleting}
            className="
              px-6 py-2 rounded-lg
              bg-red-500/80
              hover:bg-red-600
              transition-all duration-200
              disabled:opacity-50
            "
          >
            {deleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )}



{editUser && (
  <EditUser
    user={editUser}
    onClose={() => setEditUser(null)}
    onUpdated={() => {
      setEditUser(null);
      fetchEmployees(); // refresh table after update
    }}
  />
)}

{openChat && (
  <ChatDrawer
    employees={employees}
    onClose={() => setOpenChat(false)}
  />
)}

    </>
  );
}







// import { useEffect, useState } from "react";
// import { getEmployeesApi, deleteUserApi } from "../../app/api";
// import EditUser from "../employees/EditUser";

// import { useNavigate } from "react-router-dom";
// import { User } from "lucide-react";
// import { createPortal } from "react-dom";
// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

// export default function Employees() {
//   const [editUser, setEditUser] = useState(null);
//   const navigate = useNavigate();

//   const [employees, setEmployees] = useState([]);
//   const [filteredEmployees, setFilteredEmployees] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [search, setSearch] = useState("");

//   const [deleteUser, setDeleteUser] = useState(null);
//   const [deleting, setDeleting] = useState(false);

//   const fetchEmployees = async () => {
//     setLoading(true);
//     try {
//       const res = await getEmployeesApi({
//         page: 1,
//         limit: 1000,
//         search,
//         role_id: 2,
//       });
//       setEmployees(res.success ? res.data || [] : []);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchEmployees();
//   }, [search]);

//   useEffect(() => {
//     const keyword = search.toLowerCase().trim();
//     if (!keyword) {
//       setFilteredEmployees(employees);
//       return;
//     }

//     const filtered = employees.filter((emp) => {
//       const fullName =
//         `${emp.first_name} ${emp.last_name}`.toLowerCase();
//       return (
//         fullName.includes(keyword) ||
//         emp.email?.toLowerCase().includes(keyword)
//       );
//     });

//     setFilteredEmployees(filtered);
//   }, [search, employees]);

//   const confirmDelete = async () => {
//     if (!deleteUser) return;
//     setDeleting(true);
//     try {
//       const res = await deleteUserApi(deleteUser.id);
//       if (res.success) {
//         setDeleteUser(null);
//         fetchEmployees();
//       }
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const formatDate = (d) =>
//     new Date(d).toLocaleDateString("en-IN");

//     const sortedEmployees = [...filteredEmployees].sort((a, b) => {
//       const nameA = `${a.first_name || ""} ${a.last_name || ""}`.toLowerCase();
//       const nameB = `${b.first_name || ""} ${b.last_name || ""}`.toLowerCase();
//       return nameA.localeCompare(nameB);
//     });
    

//   return (
//     <>
//       <div className="
//         rounded-2xl p-5 md:mt-20
//         bg-gradient-to-br
//         from-[#2d1c6a] via-[#24155a] to-[#12082f]
//         text-white border border-white/10
//         shadow-2xl
//       ">
//         {/* Header */}
//         <div className="flex flex-col  justify-between items-start mb-4 gap-2">
//           <h3 className="font-bold text-2xl">Employees</h3>
//           <input
//             placeholder="Search by name or email"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             className="px-10 py-1.5 rounded-md bg-white/10  text-sm shadow-lg"
//           />
//         </div>

//         {/* Table */}
//        <div className="overflow-x-auto rounded-md">
//           <table className="min-w-[820px] w-full border-collapse rounded-md text-sm shadow-lg">
//             <thead className=" text-white border-b border-white/10">
//               <tr>
//                 <th className="text-left w-[260px]">Name</th>
//                 <th className=" text-left w-[260px]">Email</th>
//                 <th className=" text-left w-[110px]">Role</th>
//                 <th className="text-left w-[180px]">Job</th>
//                 <th className="text-left w-[100px]">Joined</th>
//                 <th className="text-left w-[80px] ">Edit</th>
//                 <th className="text-left w-[90px] ">Delete</th>
//               </tr>
//             </thead>

//             <tbody>
//               {loading && (
//                 <tr>
//                   <td colSpan="7" className="py-6 text-center opacity-60">
//                     Loading...
//                   </td>
//                 </tr>
//               )}

//               {!loading &&
//                 // filteredEmployees.map((emp) => (
//                   sortedEmployees.map((emp) => (

//                   <tr
//                     key={emp.id}
//                     className="border-b py-5 border-white/5 hover:bg-white/5"
//                   >
//                     {/* Name */}
//                     <td className=" py-2 w-[260px]">
//                       <div
//                         className="flex items-center gap-3 cursor-pointer"
//                         onClick={() => navigate(`/users/${emp.id}`)}
//                       >
//                         <div className="w-8 h-8 rounded-full bg-white/20 overflow-hidden">
//                           {emp.profile_pic ? (
//   <img
//     src={`${IMAGE_BASE_URL}${emp.profile_pic}`}
//     className="w-full h-full object-cover"
//   />
// ) : (
//   <div className="w-full h-full flex items-center justify-center bg-white/10">
//     <User size={18} className="text-white/60" />
//   </div>
// )}

//                         </div>

//                         <span className="font-medium truncate">
//                           {emp.first_name} {emp.last_name}
//                         </span>
//                       </div>
//                     </td>

//                     {/* Email */}
//                     <td className="w-[260px] truncate opacity-80">
//                       {emp.email}
//                     </td>

//                     {/* Role */}
//                     <td className="w-[110px]">
//                       <span className="
//                         px-2 py-1 rounded-full
//                         bg-blue-500/20 text-blue-300
//                         text-xs
//                       ">
//                         {emp.role_name}
//                       </span>
//                     </td>

//                     {/* Job */}
//                     <td className="w-[180px] truncate">
//                       {emp.job_title || "—"}
//                     </td>

//                     {/* Joined */}
//                     <td className="w-[100px] text-xs opacity-70">
//                       {formatDate(emp.created_at)}
//                     </td>

//                     {/* Edit */}
//                     <td className="w-[80px] text-center">
//                       <button
//                         // onClick={() => navigate(`/users/${emp.id}/edit`)}
//                         onClick={() => setEditUser(emp)}
//                         className="px-3 py-1 rounded bg-white/10 hover:bg-white/20 text-xs"
//                       >
//                         Edit
//                       </button>
//                     </td>

//                     {/* Delete */}
//                     <td className="w-[90px] text-center">
//                       <button
//                         onClick={() => setDeleteUser(emp)}
//                         className="px-3 py-1 rounded bg-red-500/20 text-red-300 hover:bg-red-500 hover:text-white text-xs"
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Delete Modal */}
    
// {deleteUser &&
//   createPortal(
//     <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-md">
      
//       <div
//         className="
//           relative
//           w-full max-w-md
//           p-8
//           rounded-2xl
//           bg-white/10
//           backdrop-blur-xl
//           border border-white/20
//           shadow-[0_0_40px_rgba(0,0,0,0.6)]
//           text-white
//         "
//       >
//         {/* Soft glow border effect */}
//         <div className="absolute inset-0 rounded-2xl border border-white/10 pointer-events-none"></div>

//         <h3 className="text-xl font-semibold mb-3 tracking-wide">
//           Delete Employee
//         </h3>

//         <p className="text-sm text-white/70 mb-8">
//           Are you sure you want to delete{" "}
//           <span className="font-medium text-white">
//             {deleteUser.first_name} {deleteUser.last_name}
//           </span>
//           ?
//         </p>

//         <div className="flex justify-end gap-4">
//           <button
//             onClick={() => setDeleteUser(null)}
//             className="
//               px-6 py-2 rounded-lg
//               bg-white/15
//               hover:bg-white/25
//               transition-all duration-200
//             "
//           >
//             Cancel
//           </button>

//           <button
//             onClick={confirmDelete}
//             disabled={deleting}
//             className="
//               px-6 py-2 rounded-lg
//               bg-red-500/80
//               hover:bg-red-600
//               transition-all duration-200
//               disabled:opacity-50
//             "
//           >
//             {deleting ? "Deleting..." : "Delete"}
//           </button>
//         </div>
//       </div>
//     </div>,
//     document.body
//   )}



// {editUser && (
//   <EditUser
//     user={editUser}
//     onClose={() => setEditUser(null)}
//     onUpdated={() => {
//       setEditUser(null);
//       fetchEmployees(); // refresh table after update
//     }}
//   />
// )}

//     </>
//   );
// }






